import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './DirectLossesRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';

interface DirectLossesHeaderProps {
  helmet: HeaderHelmetProps;
  showPercentPointChange?: boolean;
  showDollarChange?: boolean;
}

export default function DirectLossesHeader({
  helmet,
  showPercentPointChange,
  showDollarChange
}: DirectLossesHeaderProps) {
  const { showBenchmark, year } = useContext(AppContext);

  return (
    <div
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}
      data-testid="direct-losses-row-header">
      <HeaderHelmet {...helmet} />
      <h5 className="column_align_right">{showPercentPointChange ? '%/Pt. Change' : ''}</h5>
      <h5 className="column_align_right">{showDollarChange ? '$ Change' : ''}</h5>
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      <h5 className="column_align_right">{year} DLP*</h5>
      <h5 className="column_align_right">{year} % of Total</h5>
      <h5 className="column_align_right">{year - 1} DLP*</h5>
      <h5 className="column_align_right">{year - 1} % of Total</h5>
      <h5 className="column_align_right">{year - 2} DLP*</h5>
      <h5 className="column_align_right">{year - 2} % of Total</h5>
    </div>
  );
}
